import type { WalletTokenInfo } from '../constants/tokens'

export async function addTokenToMetaMask(asset: WalletTokenInfo): Promise<boolean> {
  if (!window.ethereum?.request) {
    throw new Error('MetaMask or compatible wallet not found')
  }

  const result = await window.ethereum.request({
    method: 'wallet_watchAsset',
    params: {
      type: 'ERC20',
      options: {
        address: asset.address,
        symbol: asset.symbol,
        decimals: asset.decimals,
        image: asset.image,
      },
    },
  })

  return Boolean(result)
}
